import type { Item, Subscale } from '@/lib/schema/types';
import { scoreItem, type ResponseMap } from './itemScore';

export interface SubscaleScoreResult {
  /** Mean of non-NA item scores, or null if no item is yet fully scored. */
  average: number | null;
  /** Count of items that contributed to the average. */
  scoredItems: number;
  /** Count of items marked NA (item-level) and excluded. */
  naItems: number;
  /** Count of items with no decisive score yet. */
  pendingItems: number;
  /** Per-item results for downstream display. */
  itemResults: Array<{
    item: Item;
    score: number | null;
    itemNa: boolean;
    complete: boolean;
  }>;
}

export function scoreSubscale(
  subscale: Subscale,
  responses: ResponseMap,
  itemNaMap: Record<string, boolean> = {},
): SubscaleScoreResult {
  let sum = 0;
  let scored = 0;
  let na = 0;
  let pending = 0;
  const itemResults: SubscaleScoreResult['itemResults'] = [];

  for (const item of subscale.items) {
    const r = scoreItem(item, responses, { itemNa: itemNaMap[item.id] });
    itemResults.push({
      item,
      score: r.score,
      itemNa: r.itemNa,
      complete: r.complete,
    });
    if (r.itemNa) {
      na += 1;
    } else if (r.score != null && r.complete) {
      sum += r.score;
      scored += 1;
    } else {
      pending += 1;
    }
  }

  return {
    average: scored > 0 ? sum / scored : null,
    scoredItems: scored,
    naItems: na,
    pendingItems: pending,
    itemResults,
  };
}
